import React from 'react';
import PropTypes from 'prop-types';
import ReadMoreText from '../ReadMoreText';

const TagsDisplay = (props) => {
  const { tags } = props;
  const { tagsGroupName } = props;
  return (
    <div className="row">
      <div className="shrink columns mb-base small-p-0">
        <p className="meta mb-xxxs">{ tagsGroupName }</p>
        <ReadMoreText text={tags.join(', ')} />
      </div>
    </div>
  );
};

TagsDisplay.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  tagsGroupName: PropTypes.string.isRequired,
};

export default TagsDisplay;
